import { CloseOutlined } from '@ant-design/icons';
import { Col, Row, Space } from 'antd';
import get from 'lodash/get';

const HospitalRejectionDetails = ({ toggleHospitalRejectMessage, details }) => {
  return (
    <div className="add-drawer-content">
      <Row justify="space-between">
        <Col className="drawer-title">Hospital Rejection Message</Col>
        <Col>
          <CloseOutlined onClick={toggleHospitalRejectMessage} />
        </Col>
      </Row>
      <div className="add-drawer-form">
        <Space size="large" direction="vertical">
          <div>
            <div>
              {get(details, 'reject_reason')} 
              {console.log("details", get(details))}
            </div>
          </div>
        </Space>
      </div>
    </div>
  );
};

export default HospitalRejectionDetails;
